import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({ 
   providedIn : 'root'
})
export class AdminService{
    constructor( private http : HttpClient ){}
   
    getData(){
        return this.http.get("https://e-commerce-page-test-default-rtdb.firebaseio.com/checkOutData.json");
    }
}